import Barba from "barba.js";
import $ from 'jquery';

const Home = Barba.BaseView.extend({
  namespace: "home",
  onEnter() {
    if (navigator.appVersion.indexOf("Win")!=-1) {
      $('.module__sub span').css('line-height','1.5');
    }
  },
  onEnterCompleted() {

    const filterParams = {
      category: null,
      type: null,
      location: null
    }

    const disableType = () => {
      $('.type-select-container').addClass('disabled');
      $('.type-select').val("all").change();
    }

    const enableType = () => {
      $('.type-select-container').removeClass('disabled');
    }

    $('.category-select').change(function(){
      if($(this).val() == "all"){
        filterParams.category = null;
        enableType()
      }
      else if($(this).val() == "service"){
        filterParams.category = $(this).val();
        enableType();
      }
      else{
        filterParams.category = $(this).val();
        disableType();
      }
    });

    $('.type-select').change(function(){
      if($(this).val() == "all"){
        filterParams.type = null;
      }
      else{
        filterParams.type = $(this).val();
      }
    });

    $('.location-select').change(function(){
      if($(this).val() == "all"){
        filterParams.location = null;
      }
      else{
        filterParams.location = $(this).val();
      }
    });


    $('.widget__submit').click(function(){
      gotoURL();
    })

    const ifExists = (value, string) => {
      if(value){
        return value;
      }
      else{
        return null;
      }
    }

    const gotoURL = () => {
      let cat = filterParams.category;
      let type = filterParams.type;
      let loc = filterParams.location;
      Barba.Pjax.goTo(`/directory?${cat ? 'cat=' + cat + '&': ''}${type ? 'type=' + type + '&': ''}${loc ? 'loc=' + loc + '': ''}`)
      // window.location.href = '/directory';
    }

  },
  onLeave() {
    this.destroy();
  },
  $el: null,
  _construct() {},
  destroy() {}
});

export default Home;



// WEBPACK FOOTER //
// ./src/scripts/barba/views/home.js